package com.starparty.app.astro0.event

import com.starparty.app.astro0.SP_Time

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */


class SP_TimeEvent(public val startTime: SP_Time,
                   public val deltaT: Double)  {


}

